var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/infoCircleIcon.6d640be8.png","uri@2x": __webpack_public_path__ + "static/media/infoCircleIcon.2843bb67.png","uri@3x": __webpack_public_path__ + "static/media/infoCircleIcon.ef8da6df.png",
    width: 12,
    height: 12
});